var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-img',{attrs:{"src":_vm.src ? _vm.originalSrc : '',"max-width":_vm.maxWidth || '100px',"max-height":_vm.maxHeight || '100px'}})
}
var staticRenderFns = []

export { render, staticRenderFns }